import { render, staticRenderFns } from "./DatosAliados.vue?vue&type=template&id=673f3450"
import script from "./DatosAliados.vue?vue&type=script&lang=js"
export * from "./DatosAliados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports